module.exports = __webpack_public_path__ + "static/media/t_de.c5b4a01d.pdf";